import { useState } from "react";
import { LoaderCircle, Search } from "lucide-react";
import moment from "moment";
import FormModal from "../../../components/customComponents/common/FormModel";
import InvoiceRegisterSubTable from "../../customComponents/tables/InvoiceRegisterSubTable";
import api from "../../../utils/axiosInstance";
import SalesReturnRegisterSubTable from "../../customComponents/tables/SalesReturnRegisterSubTable";
import {
  formatDateFullYear,
  to2Decimal,
} from "../../customComponents/common/caseFormat";
import exportCSV from "../../customComponents/common/exportCSV";
import { ActionButton } from "../../customComponents/common/Buttons";
import { SearchBox } from "../../customComponents/common/SearchBox";

const TableRow = ({ item, columnWidths }) => {
  const [invoiceDetail, setInvoiceDetail] = useState([]);
  const [salesReturnDetail, setSalesReturnDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [showInvoiceReportSubTable, setShowInvoiceReportSubTable] =
    useState(false);
  const [showSalesReturnReportSubTable, setShowSalesReturnReportSubTable] =
    useState(false);

  const getSalesReturnDetail = async (rowData) => {
    try {
      setIsLoading(true);
      setShowSalesReturnReportSubTable(true);
      const response = await api.post(
        "/branch-reports/sales-return-register-details",
        {
          rowData,
        }
      );
      console.log("sales return Detail:", response);

      if (response.data.success) {
        setSalesReturnDetail(response.data.data);
      } else {
        setSalesReturnDetail([]);
      }
    } catch (error) {
      console.log(error);
      setShowSalesReturnReportSubTable(false);
    } finally {
      setIsLoading(false);
    }
  };

  const getInvoiceDetail = async (rowData) => {
    try {
      setIsLoading(true);
      setShowInvoiceReportSubTable(true);
      console.log("rowData :", rowData);
      const response = await api.post("/branch-reports/invoice-register-details", {
        rowData,
      });
      console.log("invoice Detail in ledger table:", response);

      if (response.data.success) {
        setInvoiceDetail(response.data.data);
      } else {
        setInvoiceDetail([]);
      }
    } catch (error) {
      console.log(error);
      // showToast(
      //   "error",
      //   error.response?.data?.message || "Failed to get invoice detail"
      // );
      setShowInvoiceReportSubTable(false);
    } finally {
      setIsLoading(false);
    }
  };

  const getRecordDetails = (item) => {
    console.log("item data from row: ",item)
    // recordno,cashcr,fyear,debit-credit,type
    const credit = parseFloat(item.credit) || 0;
    const debit = parseFloat(item.debit) || 0;
    const rowData = {
      invno: item.recordno,
      cashcr: item.cashcr,
      fyear: item.fyear,
      billam: debit - credit,
      type: item.type,
    };

    if (rowData.invno === 0) {
      return;
    } else {
      if (rowData.type === "A" || rowData.type === "H") {
        console.log("type");
        getInvoiceDetail(rowData);
      } else if (rowData.type === "B") {
        getSalesReturnDetail(rowData);
      }
    }
  };
  return (
    <>
      <div
        // onClick={() => getRecordDetails(item)}
        className={`flex px-3 py-3 font-semibold cursor-pointer hover:text-black/80 transition-colors duration-200 text-sm border-b border-gray-300`}
      >
        <p
          className="px-1"
          style={{ flexBasis: columnWidths.date, flexShrink: 0 }}
        >
          <span className={`px-2 py-1`}>
            {moment(item.date).format("DD-MMM-YY")}
          </span>
        </p>
        <p
          className="cursor-pointer px-1"
          style={{ flexBasis: columnWidths.narration, flexShrink: 0 }}
        >
          {item.narr1} {item.narration}
        </p>
        <p
          className="text-right px-1"
          style={{ flexBasis: columnWidths.debit, flexShrink: 0 }}
        >
          <span className={` px-2 py-1 squircle-a-8`}>
            ₹ {to2Decimal(item.debit)}
          </span>
        </p>
        <p
          className="text-right px-1"
          style={{ flexBasis: columnWidths.credit, flexShrink: 0 }}
        >
          <span className={`px-2 py-1`}>₹ {to2Decimal(item.credit)}</span>
        </p>
      </div>
      {showInvoiceReportSubTable && (
        <FormModal
          isOpen={showInvoiceReportSubTable}
          onClose={() => setShowInvoiceReportSubTable(false)}
          formName="Invoice Report"
          onSave={() => setShowInvoiceReportSubTable(false)}
          onBack={() => setShowInvoiceReportSubTable(false)}
          saveBtn={false}
          cancelBtn={false}
          backBtn={true}
          squircleParent={13}
          squircleTopBar={7}
          customStyle="lg:min-w-[1000px] lg:max-w-[1000px] h-[600px] mx-auto z-50"
        >
          <InvoiceRegisterSubTable
            isLoading={isLoading}
            subTableData={invoiceDetail}
          />
        </FormModal>
      )}
      {showSalesReturnReportSubTable && (
        <FormModal
          isOpen={showSalesReturnReportSubTable}
          onClose={() => setShowSalesReturnReportSubTable(false)}
          formName="Sales Report"
          onSave={() => setShowSalesReturnReportSubTable(false)}
          onBack={() => setShowSalesReturnReportSubTable(false)}
          backBtn={false}
          saveBtn={false}
          cancelBtn={false}
          squircleParent={13}
          squircleTopBar={7}
          customStyle="lg:min-w-[1000px] lg:max-w-[1000px] h-[600px] mx-auto z-50"
        >
          <SalesReturnRegisterSubTable
            isLoading={isLoading}
            subTableData={salesReturnDetail}
          />
        </FormModal>
      )}
    </>
  );
};

const AccountLedgerTable = ({ tableData, isLoading }) => {
  console.log("table data from account ledger: ",tableData)
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  if (!tableData) return null;
  let filteredInvoices = tableData?.registerData || [];

  if (search.trim()) {
    const searchfilter = search.trim();
    filteredInvoices = filteredInvoices.filter(
      (item) =>
        item.narr1?.toLowerCase().includes(searchfilter.toLowerCase()) ||
        item.narration?.toLowerCase()?.includes(searchfilter.toLowerCase())
    );
  }

  // Define column widths using rem
  const columnWidths = {
    date: "35%",
    narration: "35%",
    credit: "15%",
    debit: "15%",
  };

  const columns = [
    { key: "date", label: "Date", format: formatDateFullYear },
    { key: "narr1", label: "Narration" },
    { key: "debit", label: "Debit", format: to2Decimal },
    { key: "credit", label: "Credit", format: to2Decimal },
  ];

  // csv export function
  const handleCsvExport = () => {
    if (!filteredInvoices.length) return;
    exportCSV(filteredInvoices, columns, "account-ledger-table");
  };

  return (
    <div
      className={`w-full h-full min-h-[] text-sm flex flex-col overflow-hidden border rounded-[15px] shadow-custom-light`}
    >
      {/* Search Section */}
      <div className="w-full bg-sixth text-[#ffffff]">
        <div className="flex justify-between items-center px-4 pt-3">
          <div className="flex items-center gap-2 px-2 py-1 md:w-80">
            <SearchBox
              placeholder="Search orders..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              disabled={isLoading || Object.keys(tableData).length === 0}
            />
          </div>
          {filteredInvoices?.length > 0 && (
            <ActionButton
              text={"Export CSV"}
              onClick={handleCsvExport}
              customStyle=""
            />
          )}
        </div>
      </div>
      {/* Scrollable Table Body */}
      <div className="flex flex-1 flex-col overflow-auto min-h-0">
        <div className="flex flex-col flex-1 min-h-0 min-w-fit">
          {/* Table Header */}
          <div
            className={`flex font-semibold px-3 py-2 bg-sixth text-[#ffffff] flex-shrink-0`}
          >
            <p
              className="px-1"
              style={{ flexBasis: columnWidths.date, flexShrink: 0 }}
            >
              Date
            </p>
            <p
              className="px-1"
              style={{ flexBasis: columnWidths.narration, flexShrink: 0 }}
            >
              Narration
            </p>
            <p
              className="text-right px-1"
              style={{ flexBasis: columnWidths.debit, flexShrink: 0 }}
            >
              Debit
            </p>
            <p
              className="text-right px-1"
              style={{ flexBasis: columnWidths.credit, flexShrink: 0 }}
            >
              Credit
            </p>
          </div>

          {/* Rows */}
          <div className="flex h-[280px] flex-col overflow-y-auto overflow-x-hidden">
            {isLoading ? (
              <p className="w-full h-36 flex justify-center items-center">
                <LoaderCircle className="animate-spin" />
              </p>
            ) : filteredInvoices.length > 0 ? (
              filteredInvoices.map((item) => (
                <TableRow
                  key={item.recordno}
                  item={item}
                  columnWidths={columnWidths}
                />
              ))
            ) : (
              <p className="w-full h-36 flex justify-center items-center">
                No record found...
              </p>
            )}
          </div>

          {/* Table Footer */}
          {!isLoading && (
            <div className="flex-shrink-0 bg-sixth text-white">
              <div className={`flex font-semibold px-3 py-2 `}>
                <p
                  className="px-1"
                  style={{
                    flexBasis: `calc(${columnWidths.date} + ${columnWidths.narration})`,
                    flexShrink: 0,
                  }}
                >
                  Total - {`(${filteredInvoices.length} Items)`}
                </p>
                <p
                  className="text-right px-1"
                  style={{ flexBasis: columnWidths.debit, flexShrink: 0 }}
                >
                  {tableData?.summary?.totalDb ? "₹" : ""}{" "}
                  {to2Decimal(tableData?.summary?.totalDb)}
                </p>
                <p
                  className="text-right px-1"
                  style={{ flexBasis: columnWidths.credit, flexShrink: 0 }}
                >
                  {tableData?.summary?.totalCr ? "₹" : ""}{" "}
                  {to2Decimal(tableData?.summary?.totalCr)}
                </p>
              </div>
              <div
                className={`flex font-semibold px-3 pb-2 bg-[var(--table-header-footer-bg)]`}
              >
                <p
                  className="px-1"
                  style={{
                    flexBasis: `calc(${columnWidths.date} + ${columnWidths.narration})`,
                    flexShrink: 0,
                  }}
                >
                  Balance
                </p>
                <p
                  className="text-right px-1"
                  style={{
                    flexBasis: `calc(${columnWidths.credit} + ${columnWidths.debit})`,
                    flexShrink: 0,
                  }}
                >
                  {tableData?.summary?.currentBal ? "₹" : ""}{" "}
                  {to2Decimal(tableData?.summary?.currentBal)}{" "}
                  {tableData?.summary?.currentBalLast}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccountLedgerTable;
